// @flow

import CheckboxSliderModel from './data-model';
import { default as CheckboxSliderTemplate } from './template.html';

export const COMPONENTS_CHECKBOX_SLIDER_NAME = 'checkbox-slider';

export const COMPONENTS_CHECKBOX_SLIDER_ENTITIES = [
	{
		name: COMPONENTS_CHECKBOX_SLIDER_NAME,
		entity: CheckboxSliderModel,
		template: CheckboxSliderTemplate,
	},
];